module.exports = __webpack_public_path__ + "img/program-vdp.62fa3cb6.png";